import { render, staticRenderFns } from "./ResumeChart.vue?vue&type=template&id=60ed8774"
import script from "./ResumeChart.vue?vue&type=script&lang=ts"
export * from "./ResumeChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports